import { render, staticRenderFns } from "./AtlasconcordeLogo.vue?vue&type=template&id=1c989c34&scoped=true&"
var script = {}
import style0 from "./AtlasconcordeLogo.vue?vue&type=style&index=0&id=1c989c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c989c34",
  null
  
)

export default component.exports